import { render, staticRenderFns } from "./addBackModal.vue?vue&type=template&id=894af6c4&scoped=true&"
import script from "./addBackModal.vue?vue&type=script&lang=js&"
export * from "./addBackModal.vue?vue&type=script&lang=js&"
import style0 from "./addBackModal.vue?vue&type=style&index=0&id=894af6c4&prod&lang=less&scoped=true&"
import style1 from "./addBackModal.vue?vue&type=style&index=1&id=894af6c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894af6c4",
  null
  
)

export default component.exports